module.exports = __webpack_public_path__ + "static/media/tiktok.9a5e335d.svg";